<div class="location-dropdown-dialog">
  <div class="location-dropdown-dialog-header flex-between-center">
    <!-- <p class="m-0 font-bold">{{ isMultiLocationEnabled ? 'Switch location' : 'Location' }}</p> -->
    <p class="m-0 font-18 font-600">Select store</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="location-dropdown-dialog-body flex-column flex-wrap flex-start-start">
    <div>Select from the list of stores below</div>
    <app-dropdown
      id="location-list"
      listId="location-type-list"
      theme="border"
      label="Locations"
      class="w-100"
      styleClass="pl-0"
      styleClassSelectedView="pl-2"
      [isDropdownIconVisible]="true"
      styleClassLabel="left-2"
      inactiveItemsKey="active"
      placeholder="Select store"
      [floatingLabel]="false"
      [fontSize]="14"
      field="name"
      [value]=""
      [options]="companyLocations"
      (appSelect)="handleChange($event)"
    >
      <ng-template let-item appTemplate="item">
        <span [ngClass]="{ disabled: item?.disabled }" [pTooltip]="item?.disabled ? 'Store is already added' : ''" class="font-12"> {{ item.name }}</span>
      </ng-template>
    </app-dropdown>
  </div>

  <div class="location-dropdown-dialog-footer">
    <div class="flex-end-center">
      <button class="btn btn-white btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
      <button class="btn btn-primary btn-submit" [disabled]="isProcessing" (click)="handleSave()">
        Select
        <i class="fal fa-spinner rotate" *ngIf="isProcessing"></i>
      </button>
    </div>
  </div>
</div>
